import { render, staticRenderFns } from "./AlterarVencimentoDialog.vue?vue&type=template&id=572c9174&"
import script from "./AlterarVencimentoDialog.vue?vue&type=script&lang=js&"
export * from "./AlterarVencimentoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports